import React, { Component } from 'react';

import AppContent from '../shared/AppContent';
import {AuthContext} from "../../authContext";
import BreadcrumbSeparator from "../shared/BreadcrumbSeparator";
import { citycadMajorVersion } from "../../configuration";
import Flex from "../shared/Flex";
import { getHelpContent } from "../data/data";
import Loading from "../shared/Loading";
import processHelpArticleContent from "./processHelpArticleContent";
import WebLink from "../shared/WebLink";
import HelpArticleSidebarContainer from "./HelpArticleSidebar";
import SideBarLink from "./SideBarLink";
import PageHeading from "../shared/PageHeading";

class HelpArticle extends Component {
  static contextType = AuthContext;
  state = {
    isLoading: true,
    id: 0,
    title: "",
    content: "",
    categoryID: 0,
    categoryName: "",
    categoryArticles: [],
    breadcrumbs: []
  };
  componentDidMount = async () => {
    const helpArticle = await getHelpContent('article', this.props.match.params.id, citycadMajorVersion);

    const category = await getHelpContent('category', helpArticle.data.categoryid, citycadMajorVersion);

    // console.log(helpArticle, category);

    let content = '<div>' + helpArticle.data.content + '</div>';
    await this.setState({
      id: helpArticle.data.id,
      isLoading: false,
      title: helpArticle.data.title,
      content: content,
      categoryID: helpArticle.data.categoryid,
      categoryName: helpArticle.data.categoryname,
      categoryArticles: category.data.content,
      breadcrumbs: helpArticle.data.breadcrumbs
    });
  };
  render() {
    if (this.state.isLoading) {
      return (
        <Loading />
      )
    } else {
      let parsedContent = processHelpArticleContent(this.state.content, this.context.navigate);
      return (
        <AppContent>
          {
            this.state.categoryID === 0
            ?
            <h3>{this.state.title}</h3>
            :
            <Flex style={{justifyContent:"flex-start"}}>
              <div>
                <WebLink onClick={() => this.context.navigate(`/help`)} >Help</WebLink><BreadcrumbSeparator />
              </div>
              {
                this.state.breadcrumbs.map(breadcrumb => {
                  return (
                    <div key={`${breadcrumb.id}`}>
                      <WebLink onClick={() => this.context.navigate(`/help/category/${breadcrumb.id}`)} >
                        {breadcrumb.name}
                      </WebLink>
                      <BreadcrumbSeparator />
                    </div>
                  )
                })
              }
              <div>
                {this.state.title}
              </div>
            </Flex>
          }
          <Flex alignTop>
            <HelpArticleSidebarContainer>
              {
                this.state.categoryArticles.length > 0
                &&
                this.state.categoryArticles.map(article => {
                  return (
                    <div key={article.id} style={{paddingBottom: "20px", fontSize: "1.2em"}}>
                      <SideBarLink current={Number(article.id) === Number(this.state.id)} href={`/help/article/${article.id}`}>
                        {article.title}
                      </SideBarLink>
                    </div>
                  )
                })
              }
            </HelpArticleSidebarContainer>
            <div>
              <PageHeading>{this.state.title}</PageHeading>
              {parsedContent}
            </div>
          </Flex>
        </AppContent>
      );
    }
  }
}

export default HelpArticle;
